import { Component, ViewEncapsulation } from '@angular/core';

import { Loader } from './loader';
import { LoaderService } from './loader.service';

@Component({
	selector: 'app-loader',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
	public loader: Loader;

	constructor(public loaderSrv: LoaderService) {
		this.loader = this.loaderSrv.getFlag;
	}
}
